import { useCallback, useState } from "react";

/** Pending files for manual post save; cleared after successful upload (Slice 17b). */
export function useAdsAssistantManualPostMediaUpload() {
  const [manualPostMediaFiles, setManualPostMediaFiles] = useState<File[]>([]);

  const clearManualPostMediaFiles = useCallback(() => {
    setManualPostMediaFiles([]);
  }, []);

  return { manualPostMediaFiles, setManualPostMediaFiles, clearManualPostMediaFiles };
}
